const mutations = {
    add(state, object) {
        state.itens.push(object);
    },
    setList(state, list) {
        state.itens = list;
    },
    setCommission(state, object) {
        state.commissions.push(object);
    },
    setObject(state, object) {
        state.item = object;
        state.item.functionalities = [];
    },
    delObject(state, object) {
        state.itens.splice(state.itens.indexOf(object), 1);
    }
};

export default mutations;